import React, { useEffect, useState } from "react";
import { Button } from "../../components/ui/button";
import Modal from "../../components/Modal";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import ProfileCard from "../../components/ProfileCard";
import { ServiceOnMount } from "../../services/serviceOnMount";
import { useParams } from "react-router-dom";
import { Skeleton } from "../../components/ui/skeleton";
import ShortenedText from "../../components/ShortenedText";
import { GoLog } from "react-icons/go";
import { toast } from "react-toastify";
import { createItemStore } from "../../stores/createItemStore";
import { requestService, requestDataMap } from "../../services";


// ========================================================
// Step 1: Zustand store instantiation
// ========================================================
const storeName = "requests";
const useItems = createItemStore(
  storeName,
  (request) => request.requestId,
  (args) => requestService.getRequests(args[0], args[1], args[2], args[3]),
  requestDataMap
);
// ========================================================

const ViewComRequest = () => {
  const [activeTab, setActiveTab] = useState("general");
  const [approveModal, setApproveModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const [showGroupModal, setShowGroupModal] = useState(false);
  const [showTargetModal, setShowTargetModal] = useState(false);
  const [showRequestorModal, setShowRequestorModal] = useState(false);
  const { requestId } = useParams();

  // ========================================================
  // Step 2: Zustand store and page hydration
  // ========================================================
  const { isLoading, fetchItems, getSortedFiltered, addOrUpdateItems } =
    useItems((state) => state);
  const filteredData = getSortedFiltered(
    (request) => request.requestId === requestId
  );
  const data = filteredData?.[0] ?? {};
  console.log(`data:`, data);
  // const showLoading = data.length === 0 && isLoading;
  // // console.log(`${storeName}:`, data);
  // useEffect(() => {
  //   fetchItems({}, [user?.id, undefined, undefined, undefined, communityId]);
  // }, [communityId, reload]);
  // ========================================================

  const handleConfirmApprove = async () => {
    try {
      if (!requestId) {
        console.error("No requestId found");
        return;
      }

      // Call API function
      const response = await requestService.acceptRequest({
        RequestId: requestId,
        Comment: "", // Optional: Modify as needed
      });

      console.log("Request approved:", response);

      // Close the modal
      setApproveModal(false);
    } catch (error) {
      console.error("Failed to approve request:", error);
    }
  };

  const handleConfirmReject = async () => {
    console.log("Confirm Reject Clicked - Request ID:", data.requestId); // Debug log

    if (!data.requestId) {
      console.error("No request ID available.");
      return;
    }

    try {
      const response = await requestService.rejectRequest({
        RequestId: data.requestId,
        Comment: "Request rejected.", // Update this if needed
      });

      console.log("Reject API Response:", response);
      toast.success("🎉 Request has been rejected successfully!", {
        autoClose: 2000,
      });
      setRejectModal(false);
    } catch (error) {
      console.error("Failed to reject request:", error);
      toast.error("❌ Failed to reject request", {
        autoClose: 2000,
      });
    }
  };

  const handleTabSwitch = (tab) => {
    setActiveTab(tab);
  };

  // const requestDataMap = (item) => {
  //   return {
  //     requestId: item?._id ?? "N/A",
  //     groupLeader:
  //       item?.group?.leaders?.length > 0
  //         ? item.group.leaders.join(", ")
  //         : "N/A",
  //     targetProfile: item?.target_profile?.name ?? "N/A",
  //     targetProfileId: item?.target_profile?._id ?? "N/A",
  //     targetEntityName: item?.target_entity?.name ?? "N/A",
  //     profileStatus:
  //       item?.target_profile?.status === "A"
  //         ? "Active"
  //         : item?.target_profile?.status === "U"
  //         ? "Suspended"
  //         : item?.target_profile?.status === "R"
  //         ? "Rejected"
  //         : "Unknown",
  //     status:
  //       item?.status === "A"
  //         ? "Approved"
  //         : item?.status === "P"
  //         ? "Pending"
  //         : item?.status === "R"
  //         ? "Rejected"
  //         : "Unknown",
  //     type:
  //       item?.type === "I"
  //         ? "Invitation"
  //         : item?.type === "A"
  //         ? "Activation"
  //         : item?.type === "S"
  //         ? "Suspension"
  //         : item?.type === "R"
  //         ? "Removal"
  //         : item?.type === "T"
  //         ? "Transaction"
  //         : item?.type ?? "N/A",
  //     groupName: item?.group?.name ?? "N/A",
  //     description: item?.description ?? "N/A",
  //     dateCreated: item?.create_date
  //       ? new Date(item.create_date).toLocaleDateString()
  //       : "N/A",
  //
  //     dateUpdated: item?.last_update
  //       ? new Date(item.last_update).toLocaleString()
  //       : "N/A",
  //     targetEmail: item?.target_entity?.authentication_string ?? "N/A",
  //   };
  // };

  // const getAllRequests = ServiceOnMount(
  //   () => requestService.getRequests(undefined, undefined, requestId),
  //   requestDataMap
  // );

  // if (getAllRequests?.data)
  //   setPage((state) => {
  //     state.requestsTable = getAllRequests.data;
  //   });

  // const requestData = getAllRequests.data?.[0] ?? {}; // Select first request
  //
  // addOrUpdateItems([requestData]);
  //
  // console.log("view request data: ", requestData);

  return (
    <div className="flex flex-col md:flex-row min-h-screen">
      <div className="flex-1 flex flex-col">
        <div className="p-8 flex flex-col">
          <div className="bg-white shadow p-4 rounded-lg">
            <div className="flex flex-col md:flex-row justify-between gap-4 md:items-center mb-6">
              {/* Left Side (Icon + Info) */}
              <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                <div className="flex items-center justify-center w-16 h-16 bg-yellow-400 rounded-full shrink-0 mx-auto sm:mx-0">
                  <GoLog className="text-white w-10 h-10" />
                </div>

                <div className="text-center sm:text-left">
                  <h1 className="text-lg font-semibold text-[#111827]">
                    Pending Request
                  </h1>
                  <div className="mt-4 sm:mt-2">
                    <div className="text-sm font-semibold text-[#6B7280]">
                      Date Created
                    </div>
                    <div className="text-sm text-[#111827]">
                      {!data.dateCreated ? (
                        <Skeleton className="w-40 h-6 mx-auto sm:mx-0" />
                      ) : (
                        data.dateCreated
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Side (Buttons) */}
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 items-center sm:justify-end">
                <Button
                  variant="destructive"
                  onClick={() => setRejectModal(true)}
                  className="w-full sm:w-auto"
                >
                  <FaTimesCircle className="mr-2" />
                  Reject
                </Button>
                <Button
                  onClick={() => setApproveModal(true)}
                  className="w-full sm:w-auto"
                >
                  <FaCheckCircle className="mr-2" />
                  Approve
                </Button>
              </div>
            </div>
          </div>

          {/* Tabs Section */}
          <div className="flex">
            <button
              onClick={() => handleTabSwitch("general")}
              className={`relative mt-5 rounded-tl-xl px-3 pr-10 py-3 text-[14px] font-bold ${
                activeTab === "general"
                  ? "text-[#111827] bg-white"
                  : "text-[#14B8A6] bg-[#F0FDFA]"
              }`}
              style={{
                clipPath: "polygon(0 0, 70% 0, 100% 100%, 0% 100%)",
              }}
            >
              General Info
            </button>
          </div>

          {activeTab === "general" && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 bg-white shadow rounded-lg p-4 sm:p-6">
              {/* Left Column */}
              <div className="flex flex-col gap-4">
                {[
                  data.status != null && {
                    label: "Status",
                    value: (
                      <div className="flex items-center h-full min-h-[40px]">
              <span
                className={`px-3 py-1 text-xs font-semibold rounded-full ${
                  data.status === "Approved"
                    ? "text-green-600 bg-green-100"
                    : data.status === "Pending"
                      ? "text-yellow-600 bg-yellow-100"
                      : data.status === "Rejected"
                        ? "text-red-600 bg-red-100"
                        : "text-gray-500 bg-gray-200"
                }`}
              >
                {data.status}
              </span>
                      </div>
                    ),
                  },
                  data.profileName != null && {
                    label: "Requestor",
                    value: (
                      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 min-h-[40px]">
                        <span className="text-sm text-[#111827]">
                          {data.profileName}
                        </span>
                        <Button
                          className="text-sm font-bold bg-transparent text-primary hover:bg-transparent p-0"
                          onClick={() => setShowRequestorModal(true)}
                        >
                          VIEW DETAILS
                        </Button>
                      </div>
                    ),
                  },
                  data.groupLeader != null && {
                    label: "Group Leader",
                    value: (
                      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 min-h-[40px]">
                        <span className="text-sm text-[#111827]">
                          <ShortenedText text={data.groupLeader} />
                        </span>
                        <Button
                          className="text-sm font-bold bg-transparent text-primary hover:bg-transparent p-0"
                          onClick={() => setShowGroupModal(true)}
                        >
                          VIEW DETAILS
                        </Button>
                      </div>
                    ),
                  },
                  data.targetProfile != null && {
                    label: "Target Profile",
                    value: (
                      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 min-h-[40px]">
                        <span className="text-sm text-[#111827]">
                          {data.targetProfile}
                        </span>
                        <Button
                          className="text-sm font-bold bg-transparent text-primary hover:bg-transparent p-0"
                          onClick={() => setShowTargetModal(true)}
                        >
                          VIEW DETAILS
                        </Button>
                      </div>
                    ),
                  },
                  data.email != null && {
                    label: "Target Email",
                    value: (
                      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 min-h-[40px]">
                        <span className="text-sm text-[#111827]">
                          {data.email}
                        </span>
                      </div>
                    ),
                  },
                  data.pocName != null && {
                    label: "POC Name",
                    value: (
                      <div className="flex items-center h-full min-h-[40px]">
                        <span className="text-sm text-[#111827]">{data.pocName}</span>
                      </div>
                    ),
                  },
                ]
                  .filter(Boolean)
                  .map((item) => (
                    <div
                      key={item.label}
                      className="flex flex-col sm:flex-row sm:items-center py-2 px-4 rounded-lg bg-gray-50"
                    >
                      <div className="sm:w-1/3 font-semibold text-gray-600 mb-1 sm:mb-0">
                        {item.label}
                      </div>
                      <div className="sm:w-2/3">{item.value}</div>
                    </div>
                  ))}
              </div>

              {/* Right Column */}
              <div className="flex flex-col gap-4">
                {[
                  data.type != null && {
                    label: "Type",
                    value: (
                      <div className="flex items-center h-full min-h-[40px]">
              <span
                className={`inline-block px-3 py-1 text-xs font-semibold rounded-full border ${
                  data.type === "Invitation"
                    ? "text-green-600 border-green-600"
                    : data.type === "Activation"
                      ? "text-blue-600 bg-white border border-blue-500"
                      : data.type === "Suspension"
                        ? "text-[#EF4444] border-red-500"
                        : "text-gray-500 border-gray-500"
                }`}
              >
                {data.type}
              </span>
                      </div>
                    ),
                  },
                  data.groupName != null && {
                    label: "Group Name",
                    value: (
                      <div className="flex items-center h-full min-h-[40px]">
                        <span className="text-sm text-[#111827]">{data.groupName}</span>
                      </div>
                    ),
                  },
                  data.description != null && {
                    label: "Description",
                    value: (
                      <div className="flex items-center h-full min-h-[40px]">
                        <span className="text-sm text-[#111827]">{data.description}</span>
                      </div>
                    ),
                  },
                ]
                  .filter(Boolean)
                  .map((item) => (
                    <div
                      key={item.label}
                      className="flex flex-col sm:flex-row sm:items-center py-2 px-4 rounded-lg bg-gray-50"
                    >
                      <div className="sm:w-1/3 font-semibold text-gray-600 mb-1 sm:mb-0">
                        {item.label}
                      </div>
                      <div className="sm:w-2/3">{item.value}</div>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Approve Modal */}
      <Modal
        isOpen={approveModal}
        onClose={() => setApproveModal(false)}
        title="Approve Request"
        description="Are you sure you want to approve this request?"
        icon={<FaCheckCircle className="text-green-500" />}
        actions={
          <div className="flex justify-between w-full">
            <Button variant="secondary" onClick={() => setApproveModal(false)}>
              Cancel
            </Button>
            <Button onClick={handleConfirmApprove} disabled={!requestId}>
              Approve
            </Button>
          </div>
        }
      />

      {/* Reject modal */}
      <Modal
        isOpen={rejectModal}
        onClose={() => setRejectModal(false)}
        title="Reject Request"
        description="Are you sure you want to reject this request?"
        icon={<FaTimesCircle className="text-red-500" />}
        actions={
          <div className="flex justify-between w-full">
            <Button variant="secondary" onClick={() => setRejectModal(false)}>
              Cancel
            </Button>
            <Button variant="destructive" onClick={handleConfirmReject}>
              Reject
            </Button>
          </div>
        }
      />

      {/* View group leader Modal */}
      <Modal
        isOpen={showGroupModal}
        onClose={() => setShowGroupModal(false)}
        title="Group Leader Details"
      >
        <div className="bg-green-100 p-4 rounded-lg mb-4 grid grid-cols-2 md:grid-cols-3 gap-4">
          <div>
            <p className="text-sm font-semibold text-gray-700">Member ID</p>
            <p className="text-base text-gray-900">A100252</p>
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-700">Date Created</p>
            <p className="text-base text-gray-900">2025-01-20</p>
          </div>
          <div className="col-span-2 md:col-span-1">
            <p className="text-sm font-semibold text-gray-700">Date Updated</p>
            <p className="text-base text-gray-900">2025-03-5</p>
          </div>
        </div>

        <div className=" text-left">
          {[
            { label: "Status", value: "Pending" },
            { label: "User Name", value: "Jovanny Morgan" },
            { label: "User Email", value: "Jovanny@gmail.com" },
            {
              label: "Profile",
              value: (
                <ProfileCard
                  name={"Gemma Truong"}
                  profileId={"A105252"}
                  dateCreated={"2025-01-10"}
                  variant="teal"
                />
              ),
            },
          ].map((item, index) => (
            <div
              key={item.label}
              className={`flex items-center flex-wrap px-4 py-2  ${
                index % 2 === 0 ? "bg-gray-100" : "bg-white"
              }`}
            >
              <p className="text-sm font-semibold text-gray-700 w-[120px] min-w-[100px]">
                {item.label}
              </p>
              <div className="text-base text-gray-900">{item.value}</div>
            </div>
          ))}
        </div>
      </Modal>

      {/* View target profile Modal */}
      <Modal
        isOpen={showTargetModal}
        onClose={() => setShowTargetModal(false)}
        title="Target Account Details"
      >
        <div className="bg-green-100 p-4 rounded-lg mb-4 grid grid-cols-2 md:grid-cols-3 gap-4">
          <div>
            <p className="text-sm font-semibold text-gray-700">Request ID</p>
            <p className="text-base text-gray-900">
              <ShortenedText text={data.requestId} />
            </p>
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-700">Date Created</p>
            <p className="text-base text-gray-900">{new Date(data.dateCreated).toLocaleString().split(",")[0]}</p>
          </div>
          <div className="col-span-2 md:col-span-1">
            <p className="text-sm font-semibold text-gray-700">Date Updated</p>
            <p className="text-base text-gray-900">{new Date(data.dateUpdated).toLocaleString().split(",")[0]}</p>
          </div>
        </div>

        <div className="text-left">
          {[
            { label: "Status", value: data.status },
            { label: "User Name", value: data.targetEntityName },
            { label: "User Email", value: data.targetEmail },
            {
              label: "Profile",
              value: (
                <ProfileCard
                  name={data.targetProfile}
                  profileId={<ShortenedText text={data.targetProfileId} />}
                  dateCreated={data.dateCreated}
                  variant="teal"
                />
              ),
            },
          ].map((item, index) => (
            <div
              key={item.label}
              className={`flex items-center flex-wrap px-4 py-2 ${
                index % 2 === 0 ? "bg-gray-100" : "bg-white"
              }`}
            >
              <p className="text-sm font-semibold text-gray-700 w-[120px] min-w-[100px]">
                {item.label}
              </p>
              <div className="text-base text-gray-900">{item.value}</div>
            </div>
          ))}
        </div>
      </Modal>

      {/* View requestor profile Modal */}
      <Modal
        isOpen={showRequestorModal}
        onClose={() => setShowRequestorModal(false)}
        title="Requestor Account Details"
      >
        <div className="bg-green-100 p-4 rounded-lg mb-4 grid grid-cols-2 md:grid-cols-3 gap-4">
          <div>
            <p className="text-sm font-semibold text-gray-700">Request ID</p>
            <p className="text-base text-gray-900">
              <ShortenedText text={data.requestId} />
            </p>
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-700">Date Created</p>
            <p className="text-base text-gray-900">{new Date(data.dateCreated).toLocaleString().split(",")[0]}</p>
          </div>
          <div className="col-span-2 md:col-span-1">
            <p className="text-sm font-semibold text-gray-700">Date Updated</p>
            <p className="text-base text-gray-900">{new Date(data.dateUpdated).toLocaleString().split(",")[0]}</p>
          </div>
        </div>

        <div className="text-left">
          {[
            { label: "Status", value: data.status },
            { label: "User Name", value: data.requestEntityName },
            { label: "User Email", value: data.requestEmail },
            {
              label: "Profile",
              value: (
                <ProfileCard
                  name={data.profileName}
                  profileId={<ShortenedText text={data.requestProfileId} />}
                  dateCreated={data.requestProfileCreateDate}
                  variant="teal"
                />
              ),
            },
          ].map((item, index) => (
            <div
              key={item.label}
              className={`flex items-center flex-wrap px-4 py-2 ${
                index % 2 === 0 ? "bg-gray-100" : "bg-white"
              }`}
            >
              <p className="text-sm font-semibold text-gray-700 w-[120px] min-w-[100px]">
                {item.label}
              </p>
              <div className="text-base text-gray-900">{item.value}</div>
            </div>
          ))}
        </div>
      </Modal>


    </div>
  );
};

export default ViewComRequest;
